<!-- <mat-icon class="close-icon">close</mat-icon>
<mat-toolbar class="Primarycolor" >Confirm here</mat-toolbar> -->

<button mat-icon-button class="close-icon" mat-dialog-close >
    <!-- <mat-icon>close</mat-icon> -->
    <img  [src]=closeimg class="iconimage"/>
  </button>
<div mat-dialog-title class="dialog-title" >
           Confirm Password
    
  </div>
        <form class="loginform" fxLayoutAlign="stretch" fxLayout="column"
            #loginForm="ngForm" (ngSubmit)="OnSubmit(username.value,password.value)">
            <mat-form-field >
                <input matInput placeholder="Enter Password" [type]="hide ? 'password' : 'text'" #username ngModel name="username" required >
                <button mat-icon-button matSuffix type="button" (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                    <!--<mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>-->
                    <img *ngIf ="!hide" [src]=playimg class="iconimage"/>
                    <img *ngIf ="hide" [src]=pauseimg class="iconimage"/>
                  </button>
            </mat-form-field>

            <mat-form-field>
                <input matInput [type]="hideC ? 'password' : 'text'" placeholder="Confirm Password" #password ngModel name="password" required>
                <button mat-icon-button matSuffix type="button" (click)="hideC = !hideC" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hideC">
                    <!--<mat-icon>{{hideC ? 'visibility_off' : 'visibility'}}</mat-icon>
                   -->
                    <img *ngIf ="!hideC" [src]=playimg class="iconimage"/>
                    <img *ngIf ="hideC" [src]=pauseimg class="iconimage"/>
                  </button>
            </mat-form-field>
            <!-- <div> -->
            <button mat-raised-button type="submit" color="primary"  [disabled]="loginForm.invalid">Submit</button>
            <!-- <button mat-button  color="primary">Skip</button> -->
            <a href="" onclick="return false;" class="skipBtn" (click)='skip()'
            ><i>Skip</i></a>
            <!-- </div> -->
            

            <!-- <button mat-raised-button color="primary" [class.spinner]="loading" [disabled]="loading" (click)="save()">Save</button> -->
        </form>
    